export default function BrandBar() {
  return (
    <div className="tw-w-full tw-h-[136px] tw-bg-white tw-flex tw-items-center tw-justify-center">
      <img
        src="/izicart/izi-logo-mark.png"
        alt="IZI"
        className="tw-h-[29px] tw-w-auto"
      />
      <span className="tw-h-9 tw-w-px tw-bg-gray-300 tw-ml-10 tw-mr-7" />
      <img
        src="/izicart/logo-dark.png"
        alt="Protega"
        className="tw-h-[19px] tw-w-auto"
      />
    </div>
  );
}
